module.exports = __webpack_public_path__ + "img/one.e781dbdc.svg";